// Basic Functions
$(document).ready(function(){

	// ##############################################
	// ################# CTA Section ################
	// ##############################################  

  $('.cta-section .phone .btn').click(function(event){
    //console.log($(this));
    if ($(window).width() >= 576) {
      event.preventDefault();
      $(this).parent('.phone').toggleClass('active');
    }
  });
  $(window).resize(function() {
  	if ($(window).width() < 576) {
      $('.cta-section .phone').removeClass('active');
    }
  });

	// ##############################################
	// #################### forms ###################
	// ##############################################  

  $('input, textarea').each(function(){
    if ($(this).attr('type') != "checkbox" && $(this).attr('type') != "radio") {
      if ($(this).val() != "") {
        $(this).addClass("has-content");
      } else {
        $(this).removeClass("has-content");
      }
    }
  });
  
  $('input, textarea').focusin(function(){
    if ($(this).attr('type') != "checkbox" && $(this).attr('type') != "radio") {
      $(this).addClass("focus");
    }
  });
  $('input, textarea').focusout(function(){
    if ($(this).attr('type') != "checkbox" && $(this).attr('type') != "radio") {
      $(this).removeClass("focus");
      if ($(this).val() != "") {
        $(this).addClass("has-content");
      } else {
        $(this).removeClass("has-content");
      }
    }
  });
  
	// ##############################################
	// ################## On Screen #################
	// ##############################################  
  
	jQuery.fn.isOnScreen = function()
	{
	    var win = jQuery(window);
 
	    var viewport = {
	        top : win.scrollTop(),
	        left : win.scrollLeft()
	    };
	    viewport.right = viewport.left + win.width();
	    viewport.bottom = viewport.top + win.height();
 
	    var bounds = this.offset();
	    bounds.right = bounds.left + this.outerWidth();
	    bounds.bottom = bounds.top + this.outerHeight();
 
	    return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));
	};
  

  // ##############################################
	// ############## Srcoll Animation ##############
	// ##############################################
  
	var animationInit = function () {
    $('.to-be-animated').each(function() {
      if ($(this).isOnScreen() && !$(this).hasClass('animated')) {
        if ($(this).data('animation-type')) {
          var $animationType = $(this).data('animation-type');
        } else {
          // Default: fadeIn
          var $animationType = "fadeIn";
        }
        var $animationSpeedCheck = $(this).data('animation-duration');
        if ($animationSpeedCheck) {
          if ($.isNumeric($animationSpeedCheck)) {
            if ($animationSpeedCheck < 10) {
              var $animationSpeed = $animationSpeedCheck + 's';
              $(this).css('-webkit-animation-duration', $animationSpeed);
              $(this).css('-o-animation-duration', $animationSpeed);
              $(this).css('animation-duration', $animationSpeed);
            }
          }
        } 
        var $animationClass = "animated " + $animationType; 
        $(this).removeClass('to-be-animated');
        $(this).addClass($animationClass);
      }
    });
	};
  if ($('.to-be-animated').length) {
    $('body').imagesLoaded(function() {
      animationInit();
    });
  }
  
  // ##############################################
	// ############### Trigger Srcoll ###############
	// ##############################################

  var didScroll;
  var lastScrollTop = 0;
  var delta = 5;

  $(window).scroll(function(event){
      didScroll = true;      
  });

  setInterval(function() {
      if (didScroll) {
          hasScrolled();
          animationInit();
          didScroll = false;
      }
  }, 250);

  function hasScrolled() {
    
    var st = $(window).scrollTop();
  
    // Make sure they scroll more than delta
    if (Math.abs(lastScrollTop - st) <= delta) 
      return;
        
    lastScrollTop = st;
  }
  
  hasScrolled();
  
  // ##############################################
	// ############## Portfolio Filter ###############
	// ##############################################

  $('.portfolio-grid .teaser-headline:visible').matchHeight();

  var filterGrid = $('.portfolio-grid');
  if (filterGrid.length) {
    $('.form-portfolio-filter .filter-button-group').on( 'click', 'button', function() {
      var filterClass = $(this).attr('data-filter');
      $(this).addClass('is-checked');
      $(this).siblings().removeClass('is-checked');
      if (filterClass != '*') {
        filterGrid.find('.filter-item').each(function(){
          if ($(this).hasClass(filterClass)) {
            $(this).show();
          } else {
            $(this).hide();
          }
        });
      } else {
        filterGrid.find('.filter-item').each(function(){
          $(this).show();
        });
      }
      $('.portfolio-grid .teaser-headline:visible').matchHeight();
    });
  }

});


// WEBPACK FOOTER //
// ./js/parts/base.js